<template>
  <page>

    <template slot="content">
      <div class="row">
        <div class="col-12">
          <estrelas></estrelas>
        </div>
        <div class="col-12">
          <UltimasOS></UltimasOS>
        </div>
      </div>
    </template>
  </page>
</template>

<script>
import Page from '@/components/Page'
import Estrelas from '../components/historico/Estrelas.vue'
import UltimasOS from '../components/historico/UltimasOS.vue'

export default {
  components: {
    Page,
    Estrelas,
    UltimasOS
},

  data() {
    return {
    }
  },

  computed: {
  },

  mounted() {

  },

  methods: {
    
  }
}
</script>

<style lang="scss" scoped>

</style>
